import { Module } from '@/modules/core/app/constants/app.constants';
import { AudienceName, AudienceRoute } from '@/modules/audience/audiences/audiences.constants';
import { AudienceRouteConfig } from '@/modules/audience/audiences/AudienceRouteConfig';

export const router = AudienceRouteConfig.factory(
  [
    {
      path: AudienceRoute.AUDIENCES,
      name: AudienceName.AUDIENCES,
      component: () => import(/* webpackChunkName: "audiences-page" */ `./pages/AudiencesPage.vue`),
    },
    {
      path: AudienceRoute.SELECTION,
      name: AudienceName.SELECTION,
      component: () => import(/* webpackChunkName: "selection-page" */ `./pages/SelectionPage.vue`),
    },
    {
      path: AudienceRoute.TARGET,
      name: AudienceName.TARGET,
      component: () => import(/* webpackChunkName: "target-page" */ `./pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.TARGET_DETAILS,
      name: AudienceName.TARGET_DETAILS,
      component: () => import(/* webpackChunkName: "target-page" */ `./pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.TARGET_DETAILS_ACTION,
      name: AudienceName.TARGET_DETAILS_ACTION,
      component: () => import(/* webpackChunkName: "target-page" */ `./pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.DETAILS,
      name: AudienceName.DETAILS,
      component: () => import(/* webpackChunkName: "details-page" */ `./pages/DetailsPage.vue`),
    },
    {
      path: AudienceRoute.MAPPING,
      name: AudienceName.MAPPING,
      component: () => import(/* webpackChunkName: "mappings-page" */ `./pages/MappingPage.vue`),
    },
    {
      path: AudienceRoute.MAPPING_DETAILS,
      name: AudienceName.MAPPING_DETAILS,
      component: () => import(/* webpackChunkName: "mappings-page" */ `./pages/MappingPage.vue`),
    },
  ],
  Module.AUDIENCE
);
